import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
    profile$: Observable<any>;
    profile: any;

    constructor(private _authService: AuthService) {
        this._authService.currentUser$
            // .pipe(map((u) => (u ? u.profile : {})))
            .subscribe((p) => (this.profile = p));
    }

    ngOnInit(): void {}
}
